import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { setupPaymentMethod } from '../paymentMethod';

export type PaymentType = 'PAYPAL';

type Params = {
	token: string;
	usage: 'OFF_SESSION' | 'ON_SESSION';
	utilityContext: UtilityContext;
	paymentType: PaymentType;
	countryCode?: string | null;
	currency?: string | null;
	firstName?: string;
	lastName?: string;
};

export async function setupBraintreePaymentMethod({
	token,
	usage,
	utilityContext,
	paymentType,
	countryCode,
	currency,
	firstName,
	lastName,
}: Params): Promise<string> {
	const setupPaymentMethodResp = await setupPaymentMethod({
		input: {
			gateway: 'BRAINTREE',
			usage,
			token,
			customer: {
				countryCode: countryCode ?? null,
				currencyCode: currency ?? null,
				billingName: null,
				firstName,
				lastName,
			},
			type: paymentType,
		},
		utilityContext,
	});

	if (!setupPaymentMethodResp.gatewayData) throw new Error('Error retrieving  setup intent');

	if (setupPaymentMethodResp.gatewayData.__typename !== 'SetupPaymentMethodBraintreeGatewayData')
		throw new Error('Error retrieving setup intent');

	return setupPaymentMethodResp.gatewayData.token;
}
